<template>
  <teleport to="#app">
    <transition name="fade-toast" mode="out-in" appear @after-leave="handleAfterLeave">
      <div v-if="show" class="toast-wrap" @click="show = false" :style="{ zIndex }">
        <div class="toast-content">
          <div class="toast-icon">
            <svg class="icon-warning" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
              <path d="M12 8V12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
          </div>
          <p class="toast-message">{{ message }}</p>
        </div>
      </div>
    </transition>
  </teleport>
</template>
<script src="./instance.js"></script>
<style lang="less" scoped>
.toast-wrap {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9999;
  cursor: pointer;

  .toast-content {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.98);
    backdrop-filter: blur(20px);
    padding: 16px 24px;
    border-radius: 12px;
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.12),
      0 0 0 1px rgba(0, 0, 0, 0.05);
    min-width: 320px;
    max-width: 480px;
    border-left: 4px solid #f56c6c;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      transform: translateY(-2px);
      box-shadow:
        0 12px 40px rgba(0, 0, 0, 0.15),
        0 0 0 1px rgba(245, 108, 108, 0.2);
    }
  }

  .toast-icon {
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: #f56c6c;
    animation: iconPulse 2s ease-in-out infinite;

    .icon-warning {
      width: 100%;
      height: 100%;
      filter: drop-shadow(0 2px 4px rgba(245, 108, 108, 0.3));
    }
  }

  .toast-message {
    margin: 0;
    font-size: 15px;
    font-weight: 500;
    color: #303133;
    line-height: 1.5;
    text-align: left;
    word-break: break-word;
  }
}

// 入场动画
.fade-toast-enter-active {
  animation: toastSlideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

// 出场动画
.fade-toast-leave-active {
  animation: toastSlideOut 0.3s cubic-bezier(0.4, 0, 1, 1);
}

@keyframes toastSlideIn {
  0% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
}

@keyframes toastSlideOut {
  0% {
    opacity: 1;
    transform: translateX(-50%) translateY(0) scale(1);
  }
  100% {
    opacity: 0;
    transform: translateX(-50%) translateY(-20px) scale(0.95);
  }
}

@keyframes iconPulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

// 响应式设计
@media screen and (max-width: 768px) {
  .toast-wrap {
    top: 60px;
    left: 16px;
    right: 16px;
    transform: none;

    .toast-content {
      min-width: auto;
      max-width: none;
    }
  }

  @keyframes toastSlideIn {
    0% {
      opacity: 0;
      transform: translateY(-20px) scale(0.9);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }

  @keyframes toastSlideOut {
    0% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
    100% {
      opacity: 0;
      transform: translateY(-20px) scale(0.95);
    }
  }
}
</style>
